import { render, staticRenderFns } from "./StudentFooter.vue?vue&type=template&id=54b4b4d5&scoped=true&"
import script from "./StudentFooter.vue?vue&type=script&lang=js&"
export * from "./StudentFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudentFooter.vue?vue&type=style&index=0&id=54b4b4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4b4d5",
  null
  
)

export default component.exports